import { DatePicker, Modal } from "antd";
import { motion } from "framer-motion";
import Textarea from "../../../../Components/Textarea";
import Input from "../../../../Components/Input";
import dayjs from "dayjs";
import { useCreateDiscountMutation } from "../../../../hooks/DiscountManagement/useCreateDiscountMutation";
import Button from "../../../../Components/Button";
import { formatNumberWithCommas } from "../../../../utils/formatNumber";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { useProducts } from "hooks/ProductsManagement/useGetProductsQuery";
import Loader from "Components/Loader";
import NairaSign from "Components/NairaSign";
import { useDebounce } from "hooks/useDebounce";
import { useParams } from "react-router-dom";
import { useGetSingleDiscountQuery } from "hooks/DiscountManagement/useGetSingleDiscountQuery";

const ProductDiscountForm = () => {
  const { id } = useParams();

  const {
    data: discount,
    isPending,
    isError,
  } = useGetSingleDiscountQuery(`${id}`);

  const data = discount?.data;
  const [payload, setPayload] = useState(discount?.data);
  const [startDate, setStartDate] = useState(data?.startDate);
  const [endDate, setEndDate] = useState("");
  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prev: any) => ({ ...prev, [name]: value }));
  };

  const [search, setSearch] = useState("");

  const [selectedProducts, setSelectedProducts] = useState<{
    [key: string]: boolean;
  }>({});
  // const [showProductModal, setShowProductModal] = useState(false);

  const { RangePicker } = DatePicker;
  // const { mutateAsync, isPending: isLoading } =
  //   useCreateDiscountMutation(payload);

  // const handleSubmit = (e: FormEvent) => {
  //   e.preventDefault();
  //   mutateAsync();
  // };

  // const debounceSearch = useDebounce(search);

  // const { data, isPending } = useProducts({
  //   search: debounceSearch,
  // });

  const handleProductSelection = (product: any) => {
    const id = product.id;
    const isSelected = !!selectedProducts[id];

    const updatedSelectedProducts = { ...selectedProducts };
    if (isSelected) {
      delete updatedSelectedProducts[id];
    } else {
      updatedSelectedProducts[id] = true;
    }

    const updatedProducts = isSelected
      ? payload.products.filter((p: string) => p !== id)
      : [...payload.products, id];

    setSelectedProducts(updatedSelectedProducts);
    setPayload((prevPayload: any) => ({
      ...prevPayload,
      products: updatedProducts,
    }));
  };

  useEffect(() => {
    setPayload(discount?.data);
    setStartDate(discount?.startDate);
    setEndDate(discount?.endDate);
  }, [discount?.data, discount?.endDate, discount?.startDate, setEndDate]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Input
        name="discountName"
        type="text"
        placeholder="Discount Name"
        value={payload?.discountName}
        onChange={handleInputChange}
        label={"Discount Name"}
      />
      <label
        htmlFor={"percentageOff"}
        className="block mb-2 text-grey text-[16px] manrope capitalize"
      >
        <div className="flex justify-between items-center">Percentage off</div>
      </label>
      <select
        id="percentageOff"
        className={
          "p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        }
        value={payload?.percentageOff}
        onChange={(e) => {
          setPayload({ ...payload, percentageOff: e?.target?.value });
        }}
      >
        <option value="" disabled>
          Choose a discount
        </option>
        {Array.from({ length: 100 }, (_, i) => i + 1).map((value) => (
          <option key={value} value={value}>
            {value}%
          </option>
        ))}
      </select>
      <div className="flex gap-[10px] mb-2 text-grey text-[16px] manrope capitalize">
        <div className="w-6/12">Start Date</div>
        <div className="w-6/12">End Date</div>
      </div>
      <RangePicker
        showTime
        className={
          "p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        }
        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
        onCalendarChange={(dates, dateStrings) => {
          if (dates && dates[0] && dates[1]) {
            const startDate = dates[0].format("YYYY-MM-DD");
            const endDate = dates[1].format("YYYY-MM-DD");

            setStartDate(startDate);
            setEndDate(endDate);

            setPayload({ ...payload, startDate, endDate });
          }
        }}
      />
      <div className="flex gap-[10px]">
        <Input
          name="maxDiscountAmount"
          type="text"
          placeholder=""
          value={payload?.maxDiscountAmount}
          // value={formatNumberWithCommas(payload?.maxDiscountAmount)}
          onChange={handleInputChange}
          label={"Max. Discount Amount"}
          className="w-full"
        />
      </div>
      {/* 
   
      <button
        onClick={() => setShowProductModal(true)}
        className="my-2 p-3 w-full bg-primary-light rounded-md"
      >
        Select Products
      </button>
      <Modal
        title={`Product${payload?.products.length === 0 ? "" : "s"}`}
        open={showProductModal}
        height={"500px"}
        className="max-w-[40rem] !w-full"
        onCancel={() => setShowProductModal(false)}
        footer={
          <Button
            className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300`}
            label={"Continue"}
            onClick={() => setShowProductModal(false)}
          />
        }
      >
        <div className="mb-3 text-grey">
          {payload?.products.length === 0 ? (
            ""
          ) : (
            <div>
              <b>
                {payload?.products.length} Product
                {payload?.products.length === 0 ? "" : "s"} selected
              </b>
            </div>
          )}
        </div>
        <div className="w-full">
          <div className="flex gap-[10px] mb-4">
            <span className="relative w-full">
              <SearchIcon />
              <input
                type="text"
                value={search}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSearch(e.target.value)
                }
                className="rounded-[10px] w-full border-[1px] border-[#ababab] text-[13px] p-[13px] pl-[35px]"
                placeholder="Search"
              />
            </span>
          </div>
          <div className="">
            {isPending && !data && <Loader />}
            {!isPending &&
              data?.data?.docs &&
              data?.data?.docs.map((product: any) => (
                <div
                  key={product.id}
                  className="mb-5 cursor-pointer"
                  onClick={() => handleProductSelection(product)}
                >
                  <div className="flex flex-row gap-[20px]">
                    <input
                      type="checkbox"
                      checked={!!selectedProducts[product.id]}
                    />
                    <img
                      src={product.images[0]}
                      alt={product.name}
                      className="h-[50px] w-[50px]"
                    />
                    <div>
                      <h3 className="font-bold">{product.name}</h3>
                      <p>
                        Unit Price: <NairaSign />
                        {product.unitPrice.toLocaleString()}
                      </p>
                      <p>
                        Bulk Price: <NairaSign />
                        {product.bulkPrice.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Modal>

      <Textarea
        label="Description"
        name={"description"}
        value={payload?.description}
        placeholder={"Description"}
        onChange={handleInputChange}
      />
      <Button
        onClick={handleSubmit}
        isLoading={isLoading}
        disabled={
          !payload.description ||
          !payload.discountName ||
          !payload.startDate ||
          !payload.endDate ||
          !payload.percentageOff ||
          payload.products.length === 0 ||
          isLoading
        }
        label={"Complete"}
      /> */}
    </motion.div>
  );
};

export default ProductDiscountForm;

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-4 absolute top-[18px] left-[15px] text-[#ababab]"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
      />
    </svg>
  );
};
